/**
 * Some illustrations bake UI text into the pixels (chat mockups, calendars,
 * before/after receipts…). Those ship an Arabic, right-to-left variant next to
 * the original as `<name>-ar.webp`. On the `ar` locale we swap to it; every
 * other image is language-neutral and returned unchanged.
 *
 * Keep this Set in sync with the `-ar.webp` files that actually exist in
 * `public/` — a src listed here MUST have its variant on disk.
 */
const AR_IMAGE_VARIANTS = new Set<string>([
  // Gates (Stack)
  '/stack-inbox.webp',
  '/stack-schedule.webp',
  '/stack-sell-card.webp',
  // How it works (Flow)
  '/hiw-ill-2-v2.webp',
  '/hiw-ill-3.webp',
  '/hiw-ill-4.webp',
  // Studio (Kasbly Create)
  '/studio-copy.webp',
  '/studio-shots.webp',
  '/feature-content.webp',
  // Setup / guardrails
  '/setup-brand.webp',
  '/setup-connect.webp',
  '/setup-guardrails.webp',
  // Sell & connect
  '/control-inbox-2.webp',
  '/connect-hub.webp',
]);

/** Returns the Arabic variant of `src` on the `ar` locale, else `src`. */
export function localizedImageSrc(src: string, locale: string): string {
  return locale === 'ar' && AR_IMAGE_VARIANTS.has(src) ? src.replace(/\.webp$/, '-ar.webp') : src;
}
